export default __webpack_public_path__ + "static/media/create_event_card_image.113f2ba1.png";